"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityInfoProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useRefreshAction_1 = require("../hooks/useRefreshAction");
const react_ui_1 = require("@pasport/react-ui");
const react_1 = require("react");
const index_1 = require("../index");
const Config_1 = require("../../Config");
const getExceededTime = (date) => {
    return new Date().getTime() - date.getTime();
};
const ActivityInfoProvider = ({ children }) => {
    const inactivityPromptAfter = (0, Config_1.getConfigValue)('AUTH_TIMEOUT_INACTIVITY') - (0, Config_1.getConfigValue)('AUTH_TIMEOUT_INACTIVITY_PROMPT_BEFORE');
    const { logout } = (0, index_1.useAuth)();
    const { latestActivity, refresh, refreshAction, initialLatestActivityCheck } = (0, useRefreshAction_1.useRefreshAction)();
    const [showPropsIn, setShowPromptIn] = (0, react_1.useState)(inactivityPromptAfter);
    const [logoutIn, setLogoutIn] = (0, react_1.useState)((0, Config_1.getConfigValue)('AUTH_TIMEOUT_INACTIVITY'));
    const [canContinue, setCanContinue] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        initialLatestActivityCheck();
        setTimeout(() => {
            setCanContinue(true);
        }, 0);
    }, []);
    (0, react_1.useEffect)(() => {
        if (logoutIn < 0)
            logout();
    }, [logoutIn]);
    const handleRefreshActivity = () => {
        refreshAction();
    };
    const handleBroadcastRefresh = () => {
        handleRefreshActivity();
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener("mousedown", handleRefreshActivity);
        window.addEventListener("keydown", handleRefreshActivity);
        useRefreshAction_1.refreshBroadcastChannel.addEventListener("message", handleBroadcastRefresh);
        return () => {
            window.removeEventListener("mousedown", handleRefreshActivity);
            window.removeEventListener("keydown", handleRefreshActivity);
            useRefreshAction_1.refreshBroadcastChannel.removeEventListener("message", handleBroadcastRefresh);
        };
    }, []);
    const recheckIfExceeded = () => {
        const diff = getExceededTime(latestActivity);
        const promptTimeout = inactivityPromptAfter - diff;
        const logoutTimeout = (0, Config_1.getConfigValue)('AUTH_TIMEOUT_INACTIVITY') - diff;
        setShowPromptIn(promptTimeout);
        setLogoutIn(logoutTimeout);
    };
    (0, react_1.useEffect)(() => {
        const intervalId = setInterval(() => {
            recheckIfExceeded();
        }, 1000);
        return () => clearInterval(intervalId);
    }, [latestActivity]);
    const handleContinuePress = () => {
        refresh();
        recheckIfExceeded();
    };
    const logoutTimeoutSecs = Math.max(Math.round(logoutIn / 1000), 0);
    if (!canContinue) {
        return (0, jsx_runtime_1.jsx)(react_ui_1.CenterView, { children: "..." });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { onMouseDown: () => console.log("mouse down was triggered"), children: (0, jsx_runtime_1.jsxs)(react_ui_1.Modal, { show: showPropsIn < 0, onClose: handleContinuePress, children: [(0, jsx_runtime_1.jsx)("div", { className: "fs-5 fw-bold pb-2", children: "Budete odhl\u00E1\u0161eni" }), (0, jsx_runtime_1.jsxs)("div", { className: "pb-3", children: ["V aplikaci jste ji\u017E del\u0161\u00ED dobu neprovedl/a \u017E\u00E1dnou akci. Kv\u016Fli bezpe\u010Dnosti budete z aplikace za ", logoutTimeoutSecs, " vte\u0159in automaticky odhl\u00E1\u0161eni."] }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-end", children: (0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: "success", onPress: handleContinuePress, children: "Chci pokra\u010Dovat" }) })] }) }), children] }));
};
exports.ActivityInfoProvider = ActivityInfoProvider;
